import { useState } from 'react';
import './CardUpload.css';
import PDFDownloadButton from '../GradePDF/GradePDF';
import axios from 'axios';

const API_BASE_URL =
  process.env.REACT_APP_API_URL ||
  "https://ug8mdd2lla.execute-api.us-east-1.amazonaws.com";

const CardUpload = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [preview, setPreview] = useState(null);
  const [grade, setGrade] = useState(null);
  const [confidence, setConfidence] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setSelectedImage(file);
      setPreview(URL.createObjectURL(file));
      setGrade(null);
      setError(null);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!selectedImage) return;

    setLoading(true);
    setError(null);
    setGrade(null);
    setConfidence(null);

    try {
      const formData = new FormData();
      formData.append('image', selectedImage);

      const response = await axios.post(`${API_BASE_URL}/api/process-image`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      const { grade: predictedGrade, confidence: predictedConfidence, error: apiError } = response.data;

      if (apiError) {
        throw new Error(apiError);
      }

      if (predictedGrade) {
        setGrade(predictedGrade);
        setConfidence(predictedConfidence);
      } else {
        setError('Could not determine grade from image');
      }
    } catch (error) {
      console.error('Error processing image:', error);
      
      const errorMessage = error.response?.data?.error 
        || error.response?.data?.details
        || error.message 
        || 'Error processing image';
      
      setError(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="card-upload-container">
      <h2>Upload Card Image</h2>
      
      {error && (
        <div className="error-message">
          {error}
        </div>
      )}
      
      <form onSubmit={handleSubmit} className="upload-form">
        <div className="upload-area">
          <input
            type="file"
            accept="image/*"
            onChange={handleImageChange}
            className="file-input"
            id="card-image"
          />
          <label htmlFor="card-image" className="upload-label">
            {preview ? 'Change Image' : 'Select Image'}
          </label>
        </div>

        {preview && (
          <div className="preview-container">
            <img src={preview} alt="Card preview" className="image-preview" />
          </div>
        )}

        {preview && (
          <button 
            type="submit" 
            className="grade-button"
            disabled={loading}
          >
            {loading ? 'Analyzing...' : 'Grade Card'}
          </button>
        )}

        {grade && (
          <div className="grade-results">
            <h3>Grading Results</h3>
            <div className="grade-details">
              <p>
                <strong>Predicted Grade:</strong> {grade}
              </p>
              {confidence && (
                <p>
                  <strong>Confidence:</strong> {confidence}%
                </p>
              )}
            </div>
            <div className="confidence-bar">
              <div 
                className="confidence-fill" 
                style={{ width: `${confidence}%` }}
              />
            </div>
            <div className="download-section">
              <PDFDownloadButton gradeValue={grade} />
            </div>
          </div>
        )}
      </form>
    </div>
  );
};

export default CardUpload; 